export const REGION_GROUPS = [
  {
    region: 'north-europe',
    labelKey: 'language_selector.regions.north-europe',
    locales: [
      { locale: 'fi', key: 'fi_north-europe' },
      { locale: 'en', key: 'en_north-europe' },
      { locale: 'sv', key: 'sv_north-europe' },
      { locale: 'et', key: 'et_north-europe' },
    ],
  },
  {
    region: 'europe',
    labelKey: 'language_selector.regions.europe',
    locales: [
      { locale: 'de', key: 'de_europe' },
      { locale: 'en', key: 'en_europe' },
    ],
  },
];

const KEY_TO_LOCALE = Object.fromEntries(
  REGION_GROUPS.flatMap((g) => g.locales.map((l) => [l.key, l.locale]))
);
const VALID_KEYS = Object.keys(KEY_TO_LOCALE);
export const DEFAULT_KEY = 'fi_north-europe';

export function localeOf(key) {
  return KEY_TO_LOCALE[key] || 'fi';
}

export function getActiveRegionKey() {
  try {
    const params = new URLSearchParams(window.location.search);
    const fromQuery = params.get('region');
    if (fromQuery && VALID_KEYS.includes(fromQuery)) return fromQuery;

    const stored = localStorage.getItem('harvia-region-key');
    if (stored && VALID_KEYS.includes(stored)) return stored;
  } catch (e) {
    // window or localStorage not available — fall through
  }
  return DEFAULT_KEY;
}
